function customSorting() {
  const dropdowns = document.querySelectorAll('.custom-facets');

  dropdowns.forEach(dropdown => {
    const toggleBtn = dropdown.querySelector('.dropdown-toggle');
    const options = dropdown.querySelectorAll('.dropdown-option');
    const selectedValue = dropdown.getAttribute('data-selected');
    const paramName = dropdown.getAttribute('data-name');

    const selectedOption = dropdown.querySelector(`.dropdown-option[data-value="${selectedValue}"]`);
    if (selectedOption && toggleBtn) {
      toggleBtn.innerText = selectedOption.innerText.trim();
    }

    // ✅ Toggle 'active' class when toggleBtn is clicked
    if (toggleBtn) {
      toggleBtn.addEventListener('click', () => {
        toggleBtn.classList.toggle('active');
      });
    }

    options.forEach(option => {
      option.addEventListener('click', function () {
        const value = this.getAttribute('data-value');
        const name = this.textContent.trim();

        toggleBtn.textContent = name;
        options.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');

        const url = new URL(window.location.href);
        url.searchParams.set(paramName, value);
        window.location.href = url.toString();
      });
    });
  });
}

function observeFacetsUpdate() {
  const targetNode = document.querySelector('.mobile-facets__wrapper');
  if (!targetNode) return;

  const observer = new MutationObserver(mutationsList => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        customSorting();
        break;
      }
    }
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', () => {
  observeFacetsUpdate();
  customSorting();
});
